export default "__VITE_ASSET__ccfc709e__"